





















import { Vue, Component, Prop, Watch, Emit, Ref } from "vue-property-decorator";
import { Getter } from "vuex-class";

import { merchSignin } from "../../api/net/loginApi";
import {
  SignedInUserDto,
  ILoginMerchant
} from "../../types/interface/User/UserTypes";
import store from "../../store/index";
import { sendEvent } from "../../libs/utils";
@Component
export default class SelectMerchant extends Vue {
  @Prop({ default: false }) value!: boolean;
  @Prop({ default: 500 }) width!: number;
  @Prop({ default: `Select merchant to signin` }) title!: string;
  @Prop({ default: () => [] }) items: Array<ILoginMerchant>;

  loginMerchant: ILoginMerchant = {
    autoAcceptOrder: false,
    logo: "",
    status: 0,
    merchAddress: "",
    merchName: "",
    merchId: "",
    userId: "",
    userName: ""
  };

  @Getter("merchId") merchId!: string;

  @Watch(`items`, { immediate: true, deep: true })
  onMerchantsChange(newItems: ILoginMerchant[]) {
    if (newItems.length === 1) {
      this.merchantSelected(newItems[0]);
      this.submit();
      this.$nextTick(() => {
        sendEvent("initNotification", this.merchId);
      });
    }
  }

  getLogo(logo: string) {
    return `${logo}?imageView2/2/w/80`;
  }

  public get showModal(): boolean {
    return this.value;
  }

  public set showModal(v: boolean) {
    this.$emit("input", v);
  }

  close() {
    this.$store.commit("handleShowSelectMerchantModal", false);
    store.commit("handleShowLoading", false);
  }

  merchantSelected(item: ILoginMerchant) {
    this.loginMerchant = item;
  }

  submit() {
    if (this.loginMerchant.merchId === "" || !this.loginMerchant.merchId) {
      this.$message.show({
        text: "Merchant must be selected"
      });
      return;
    }
    this.$emit("on-select", JSON.parse(JSON.stringify(this.loginMerchant)));

    this.loginMerchant = {
      autoAcceptOrder: false,
      logo: "",
      status: 0,
      merchAddress: "",
      merchName: "",
      merchId: "",
      userId: "",
      userName: ""
    };
  }
}
